export default "__VITE_ASSET__BdEZ$9M2__"